import * as React from "react";
import AnimatedLogoLineProgress from "./AnimatedLogoLineProgress"; // ajusta la ruta

type SpinnerUmmIAProps = {
  /** Tamaño del logo dentro de la tarjeta */
  logoWidth?: number;
  logoHeight?: number;
  /** Colores del logo */
  baseColor?: string;
  fillColor?: string;
  progress?: number;
};


export function useIndeterminateProgress(msPerCycle = 2600) {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    let raf = 0;
    const start = performance.now();

    const tick = (now: number) => {
      const elapsed = (now - start) % msPerCycle;
      const t = elapsed / msPerCycle; 
      const eased = 0.5 - 0.5 * Math.cos(Math.PI * 2 * t); 
      setProgress(Math.round(eased * 100));
      raf = requestAnimationFrame(tick);
    };

    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [msPerCycle]);

  return progress;
}

export default function SpinnerUmmIA({
  logoWidth = 25,
  logoHeight = 25,
  baseColor = "#D1D5DB",
  fillColor = "#336B87",
  progress,
}: SpinnerUmmIAProps) {
  const indeterminate = useIndeterminateProgress();
  const p = typeof progress === "number" ? progress : indeterminate;

  return (
          <AnimatedLogoLineProgress
            progress={p}
            width={logoWidth}
            height={logoHeight}
            baseColor={baseColor}
            fillColor={fillColor}
          />
  );
}
